/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Sparkle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Sparkle"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M8.653 7.924c.176-.626 1.064-.626 1.24 0l.573 2.044a5.15 5.15 0 0 0 3.566 3.566l2.044.574c.626.175.626 1.063 0 1.239l-2.044.574a5.15 5.15 0 0 0-3.566 3.565l-.574 2.044c-.175.627-1.063.627-1.239 0l-.574-2.044a5.15 5.15 0 0 0-3.565-3.565l-2.044-.574c-.627-.176-.627-1.064 0-1.24l2.044-.573a5.15 5.15 0 0 0 3.565-3.566zm8.414-5.63c.11-.392.665-.392.775 0L18.2 3.57a3.22 3.22 0 0 0 2.229 2.23l1.277.358c.392.11.392.665 0 .775l-1.277.358A3.22 3.22 0 0 0 18.2 9.52l-.36 1.277c-.11.392-.664.392-.774 0L16.71 9.52a3.22 3.22 0 0 0-2.23-2.23l-1.277-.358c-.392-.11-.392-.665 0-.775L14.48 5.8a3.22 3.22 0 0 0 2.229-2.228z"
      className="SVG"
    />
  </svg>
);

export const SparkleIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'sparkle-icon'}
      icon={Sparkle}
      {...props}
      size={size}
    />
  );
};
